import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    calculators: [
      { name: 'Home Loan Calculator', href: '/calculators/home-loan' },
      { name: 'EMI Calculator', href: '/calculators/emi' },
      { name: 'Tax Calculator', href: '/calculators/tax' },
      { name: 'SIP Calculator', href: '/calculators/sip' },
    ],
    comparisons: [
      { name: 'Credit Cards', href: '/comparisons/credit-cards' },
      { name: 'Loans', href: '/comparisons/loans' },
      { name: 'Insurance', href: '/comparisons/insurance' },
    ],
    guides: [
      { name: 'Tax Saving Tips', href: '/guides/tax-saving-tips' },
      { name: 'Investment Strategies', href: '/guides/investment-strategies' },
      { name: 'Stock Market Basics', href: '/guides/stock-market-basics' },
    ],
    company: [
      { name: 'About Us', href: '/about' },
      { name: 'Contact', href: '/contact' },
      { name: 'Privacy Policy', href: '/privacy' },
      { name: 'Terms of Service', href: '/terms' },
    ],
  };

  return (
    <footer className="bg-[#080037] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className=" w-10 h-10 rounded-lg flex items-center justify-center">
                <svg width="24" height="36" viewBox="0 0 15 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <mask id="mask0_3_40" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="15" height="14">
                    <path d="M10.9528 0.0479033C1.88034 1.45971 0 4.99836 0 13.1437C1.02762 9.01794 4.82687 6.40689 11.3978 5.31051C16 4.54262 14.7612 -0.544733 10.9528 0.0479033Z" fill="white" />
                  </mask>
                  <g mask="url(#mask0_3_40)">
                    <path d="M16 -0.544739H0V13.1437H16V-0.544739Z" fill="url(#paint0_linear_3_40)" />
                  </g>
                  <mask id="mask1_3_40" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="8" width="15" height="14">
                    <path d="M10.9528 8.26813C1.88034 9.67993 0 13.2186 0 21.3639C1.02762 17.2382 4.82687 14.6271 11.3978 13.5307C16 12.7628 14.7612 7.67549 10.953 8.26879" fill="white" />
                  </mask>
                  <g mask="url(#mask1_3_40)">
                    <path d="M16 7.67548H0V21.3639H16V7.67548Z" fill="url(#paint1_linear_3_40)" />
                  </g>
                  <mask id="mask2_3_40" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="15" width="5" height="9">
                    <path d="M2.3793 23.4557C3.69455 23.4557 4.77054 22.4109 4.77054 21.1338V15.6134C2.21007 16.9873 0.611472 18.9044 0 21.3639C0.12009 22.5338 1.14419 23.4553 2.3793 23.4553" fill="white" />
                  </mask>
                  <g mask="url(#mask2_3_40)">
                    <path d="M4.77054 15.6134H0V23.4553H4.77054V15.6134Z" fill="url(#paint2_linear_3_40)" />
                  </g>
                  <defs>
                    <linearGradient id="paint0_linear_3_40" x1="-0.215382" y1="6.79187" x2="12.8427" y2="5.96181" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#080037" />
                      <stop offset="1" stopColor="#14B9E2" />
                    </linearGradient>
                    <linearGradient id="paint1_linear_3_40" x1="0.305162" y1="14.9809" x2="13.3633" y2="14.1508" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#080037" />
                      <stop offset="1" stopColor="#14B9E2" />
                    </linearGradient>
                    <linearGradient id="paint2_linear_3_40" x1="2.04704" y1="23.4243" x2="2.59155" y2="16.7833" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#080037" />
                      <stop offset="1" stopColor="#14B9E2" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <span className="text-xl font-bold">Finclify</span>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              Your comprehensive financial planning companion. Calculate EMI, plan investments,
              compare financial products, and make informed decisions for a secure financial future.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Calculators */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Calculators</h3>
            <ul className="space-y-2">
              {footerLinks.calculators.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-300 hover:text-white transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Comparisons */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Comparisons</h3>
            <ul className="space-y-2">
              {footerLinks.comparisons.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-300 hover:text-white transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Guides */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Guides</h3>
            <ul className="space-y-2">
              {footerLinks.guides.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-300 hover:text-white transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {currentYear} Finclify. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              {footerLinks.company.map((link) => (
                <Link
                  key={link.name}
                  to={link.href}
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
